<template>
  <div class="up-down-arrow" :class="upDownClass">
    <img :src="arrowSrc">
    {{ absValue }}{{ unit }}
  </div>
</template>

<script>
  export default {
    name: 'up-down-arrow',

    props: {
      value: {
        type: Number,
        default: 0,
      },
      unit: {
        type: String,
        default: '',
      },
    },

    computed: {
      arrowSrc() {
        if (this.value > 0) {
          return '/static/images/ic-increase-info.svg';
        }

        return '/static/images/ic-decrease-info.svg';
      },

      absValue() {
        return Math.abs(this.value);
      },

      upDownClass() {
        return {
          increased: this.value > 0,
          decreased: this.value < 0,
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .up-down-arrow {
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    vertical-align: top;

    &.decreased {
      color: #448aff;

      img {
        vertical-align: top;
      }
    }

    &.increased {
      color: #ff595f;

      img {
        vertical-align: bottom;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UpDownArrow.vue